































































import { Vue } from "vue-property-decorator";
import type { stadium_base, stadium_curator, stadium_ground_price } from "@/@types/stadium/stadium"
import TsUpload from "@/components/upload.vue";

import Info from "@/views/invest/form/stadium_info.vue"
import Detail from "@/views/invest_log/info.vue"
import Base from "@/views/invest/detail/form/stadium_base.vue"
import Curator from "@/views/invest/detail/form/stadium_curator.vue"
import Notice from "@/views/invest/detail/form/stadium_notice.vue"
import StadiumTags from "@/views/invest/detail/form/stadium_tags.vue"
import StadiumGrounds from "@/views/invest/detail/form/stadium_grounds.vue"
import StadiumGroundPrice from "@/views/invest/detail/form/stadium_ground_price.vue"
import BusinessNewDay from "@/views/invest/detail/form/business_new_day.vue"

export default Vue.extend({
  name: "BusinessCorrectAudit",
  components: {
    Info,
    Detail,
    TsUpload,
    Base,
    Curator,
    Notice,
    StadiumTags,
    StadiumGrounds,
    StadiumGroundPrice,
    BusinessNewDay
  },
  data() {
    return {
      id        : "",
      op        : 2,
      log_id    : "",
      correct_id: "",
      active    : 1,
      visible   : false,
      loading   : false,
      reason    : "",
      correct   : {
        status: 0
      } as any,
      info: {
        reason: "",
        proof : [
          { path: "", url: "" }
        ]
      },
      stadium: {
        id             : "",
        stadium_id     : "",
        name           : "",
        status         : "",
        status_logs    : [],
        estimate_logs  : [],
        estimate_status: "0",
        confirm_status : "0",
        cooperate_info : {
          stadium_notice   : "",
          business_days_new: [],
          stadium_tags     : []
        }
      } as any,
      statuses: [
        { value: 0, label: "未开始", status: "#909399" },
        { value: 1, label: "审核中", status: "#10aeff" },
        { value: 2, label: "已通过", status: "#4cd964" },
        { value: 3, label: "不通过", status: "#f6383a" },
      ],
      editable                 : false,
      stadium_base             : {} as stadium_base,
      stadium_curator          : {} as stadium_curator,
      stadium_ground_price     : {} as stadium_ground_price,
      show_stadium_base        : {
        all          : false,
        name         : false,
        area         : false,
        addr         : false,
        contact      : false,
        sex          : false,
        contact_phone: false,
        phone        : false,
        longitude    : false,
        latitude     : false,
      },
      show_stadium_curator     : {
        all           : false,
        manager_nick  : false,
        manager_avatar: false,
      },
      show_notice              : false,
      show_tags                : false,
      show_stadium_ground      : false,
      show_business_days_new   : false,
      show_stadium_ground_price: {
        all              : false,
        is_half_time     : -1,
        is_people_bill   : -1,
        business_time    : false,
        business_time_new: false,
        origin_price     : false,
        new_price        : false,
      },
    }
  },
  methods: {
    async get_info() {
      const params = { id: this.log_id }
      const res = await this.$store.dispatch("invest_log/info", params);
      if (res.Code == 200) {
        for (const v of res.Data) {
          if (v.title == "纠错原因") this.info.reason = v.content
          if (v.title == "纠错凭证") {
            const paths = v.url.split(",")
            if (paths.length > 0) {
              this.info.proof = []
              for (const p of paths) {
                const temp = { path: p, url: this.$read_image(p) }
                this.info.proof.push(temp)
              }
            }
          }
        }
      }
    },
    async get_stadium() {
      const params = { estimate_id: this.id }
      const res = await this.$store.dispatch("invest/stadium_info", params);
      if (res.Code == 200) {
        const data = res.Data
        this.stadium = data
        const change = await this.$store.dispatch("invest_correct/info", { id: this.correct_id, op: this.op });
        if (change.Code == 200) {
          const correct = change.Data
          if (Object.prototype.hasOwnProperty.call(correct, "stadium_notice")) {
            this.stadium.cooperate_info.stadium_notice = correct.stadium_notice
            this.show_notice = true
          }
          if (Object.prototype.hasOwnProperty.call(correct, "stadium_tags")) {
            this.stadium.cooperate_info.stadium_tags = correct.stadium_tags
            this.show_tags = true
          }
          this.correct = correct
          this.handleStadiumBase(data.cooperate_info, correct)
          this.handleStadiumCurator(data.cooperate_info, correct)
          this.handleStadiumTags(correct)
          this.handleStadiumGround()
          this.handleStadiumGroundPrice(data.cooperate_info, correct)
          this.handleBusinessNewDays(correct)
        }
      }
    },
    /* 处理场馆基本信息 */
    handleStadiumBase(data: any, change: any) {
      this.stadium_base = {
        name         : data.name,
        province_id  : data.province_id,
        city_id      : data.city_id,
        county_id    : data.county_id,
        area_name    : data.area_name,
        addr         : data.addr,
        contact      : data.contact,
        sex          : data.sex,
        contact_phone: data.contact_phone,
        phone        : data.phone,
        longitude    : data.longitude,
        latitude     : data.latitude,
      }
      for (const key in change) {
        if (Object.prototype.hasOwnProperty.call(change, key)) {
          const checked = ["name", "area_name", "addr", "contact", "sex", "contact_phone", "phone", "longitude", "latitude"]
          if (checked.includes(key)) {
            this.show_stadium_base.all = true
            /* 需要特殊处理的字段 */
            if (key == "area_name") this.show_stadium_base.area = true
            this.show_stadium_base[key] = true
          }
        }
      }
      const base = this.$refs.base as any
      base.init()
    },
    handleStadiumCurator(data: any, change: any) {
      this.stadium_curator = {
        manager_nick  : data.manager_nick,
        manager_avatar: data.manager_avatar,
      }
      for (const key in change) {
        if (Object.prototype.hasOwnProperty.call(change, key)) {
          const checked = ["manager_nick", "manager_avatar"]
          if (checked.includes(key)) {
            this.show_stadium_curator.all  = true
            this.show_stadium_curator[key] = true
            // this.stadium_curator[key]      = change[key]
          }
        }
      }
    },
    handleStadiumTags(change: any) {
      if (Object.prototype.hasOwnProperty.call(change, "grounds")) this.show_stadium_ground = true
      const stadium_tags = this.$refs.stadium_tags as any
      stadium_tags.init()
    },
    handleStadiumGround() {
      const stadium_grounds = this.$refs.stadium_grounds as any
      stadium_grounds.init()
    },
    handleStadiumGroundPrice(data: any, change: any) {
      this.stadium_ground_price = {
        is_half_time     : data.is_half_time,
        is_people_bill   : data.is_people_bill,
        business_time    : data.business_time,
        business_time_new: data.business_time_new,
      }
      for (const key in change) {
        if (Object.prototype.hasOwnProperty.call(change, key)) {
          const checked = ["is_half_time", "is_people_bill", "business_time", "business_time_new", "prices"]
          if (checked.includes(key)) {
            this.show_stadium_ground_price.all = true
            if (key == "prices") {
              const items = JSON.parse(change[key])
              for (const item of items) {
                console.log("Price:", item)
                if (Object.prototype.hasOwnProperty.call(item, "type")) {
                  if (item.type == 1) this.show_stadium_ground_price.origin_price = true
                  if (item.type == 2) this.show_stadium_ground_price.new_price = true
                }
              }
            }
            if (key == "is_half_time") this.show_stadium_ground_price.is_half_time = Number(change[key])
            if (key == "is_people_bill") this.show_stadium_ground_price.is_people_bill = Number(change[key])
          }
        }
      }
      const ground_price = this.$refs.ground_price as any
      ground_price.init()
    },
    handleBusinessNewDays(change: any) {
      if (Object.prototype.hasOwnProperty.call(change, "business_days_new")) {
        this.show_business_days_new = true
      }
      const new_days = this.$refs.business_new_day as any
      new_days.init()
    },
    detail() {
      this.$nextTick(() => {
        const detail = this.$refs.detail as any
        detail.open(this.log_id)
      })
    },
    submit(result: number) {
      if (result == 1) {
        this.$confirm({
          title  : "确定审核通过？",
          content: "审核通过后，已审核过的信息将进行变更，请谨慎操作！",
          onOk   : () => this.do_submit(result)
        })
      } else {
        this.$confirm({
          title: "确定审核不通过？",
          onOk : () => { this.visible = true }
        })
      }
    },
    async do_submit(result: number, remark?: string) {
      const res = await this.$store.dispatch("invest_audit/submit", { id: Number(this.log_id), result, remark, description: remark });
      if (res.Code == 200) {
        this.$info({
          title: "审核成功！",
          onOk : () => {
            this.visible = false
            this.$router.push({ path: "/invest_audit/correct" })
          }
        })
      } else {
        this.$confirm({
          title : "审核失败！",
          okText: "重试",
          onOk  : () => this.do_submit(result)
        })
      }
    }
  },
  mounted() {
    const query = { ...this.$route.query };
    if (query.id != "") this.id = query.id as string;
    if (query.op != "") this.op = Number(query.op);
    if (query.log_id != "") this.log_id = query.log_id as string;
    if (query.correct_id != "") this.correct_id = query.correct_id as string;
  },
  watch: {
    id(id: string) {
      if (id != "") {
        this.get_stadium()
      }
    },
    log_id(log_id: string) {
      if (log_id != "") {
        this.get_info()
      }
    }
  }
})

